/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function CalendarIcon({ width = 11, height = 12 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6333 4.76774C10.5361 4.76774 10.4429 4.80629 10.3739 4.87522C10.305 4.94415 10.2667 5.03718 10.2667 5.1344V9.16774C10.2667 9.4596 10.1508 9.73932 9.94442 9.9457C9.73804 10.1519 9.45832 10.2679 9.16646 10.2679H1.83312C1.54126 10.2679 1.26154 10.1521 1.05516 9.9457C0.8492 9.73932 0.733333 9.4596 0.733333 9.16774V5.1344C0.733333 5.00345 0.663352 4.88234 0.55 4.81676C0.436648 4.75118 0.296686 4.75118 0.183333 4.81676C0.069981 4.88234 0 5.00345 0 5.1344V9.16774C0 9.65404 0.193181 10.1202 0.53701 10.4641C0.880838 10.8079 1.34703 11.0011 1.83333 11.0011H9.16667C9.65297 11.0011 10.1192 10.8079 10.463 10.4641C10.8068 10.1202 11 9.65404 11 9.16774V5.1344C11 5.03718 10.9614 4.94394 10.8925 4.87501C10.8236 4.80608 10.7306 4.76774 10.6333 4.76774Z"
        fill="black"
      />
      <path
        d="M9.16667 1.46682H8.43333V0.366824C8.43333 0.235871 8.36335 0.114767 8.25 0.0491857C8.13665 -0.0163952 7.99669 -0.0163952 7.88333 0.0491857C7.76998 0.114767 7.7 0.235662 7.7 0.366824V1.46682H3.3V0.366824C3.3 0.235871 3.23002 0.114767 3.11667 0.0491857C3.00331 -0.0163952 2.86335 -0.0163952 2.75 0.0491857C2.63665 0.114767 2.56667 0.235662 2.56667 0.366824V1.46682H1.83333C1.34703 1.46682 0.880838 1.66 0.53701 2.00383C0.193181 2.34766 0 2.81385 0 3.30016V4.03349C0 4.13071 0.0385524 4.22395 0.107486 4.29288C0.176419 4.36181 0.269448 4.40016 0.366667 4.40016H10.6333C10.7306 4.40016 10.8238 4.3616 10.8927 4.29267C10.9617 4.22374 11.0002 4.13071 11.0002 4.03328V3.29995C11.0002 2.81364 10.807 2.34745 10.4632 2.00362C10.1194 1.6598 9.65297 1.46682 9.16667 1.46682ZM10.2667 3.66682H0.733333V3.30016C0.733333 3.00829 0.8492 2.72858 1.05558 2.5222C1.26175 2.31602 1.54147 2.20016 1.83333 2.20016H9.16667C9.45853 2.20016 9.73825 2.31602 9.94463 2.5224C10.1508 2.72879 10.2669 3.0085 10.2669 3.30037V3.66682H10.2667Z"
        fill="black"
      />
    </svg>
  );
}

export default CalendarIcon;
